<template>
  <div id="app">
    <section class="hero is-medium" >
      <div class="hero-head">
        <nav class="navbar is-transparent" aria-label="main navigation">
          <div class="navbar-brand">
            <router-link :to="{ name: 'home' }" class="navbar-item">
              <img src="/static/img/ductifi_logo.svg" alt="Logo"  v-on:click="toggleNav">
            </router-link>
            <!-- TODO: How does the hamburger effectively work??  -->
            <a role="button" class="navbar-burger" aria-label="menu" aria-expanded="false" v-on:click="toggleNav">
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </a>
          </div>
          <div id="navbarMenu" class="navbar-menu" >
            <div class="navbar-start">
              <a class="navbar-item" href="https://ductifi.freshdesk.com/" v-on:click="toggleNav">Support</a>
            </div>
            <div class="navbar-end">
              <span class="navbar-item" v-on:click="toggleNav">
                <router-link :to="{ name: 'join-beta' }" class="button is-primary">Join Beta</router-link>
              </span>
              <!-- If authenticated display Login button -->
              <a class="navbar-item" v-if="!authenticated" v-on:click="login()">Login</a>
              <!-- Otherwise... -->
              <a class="navbar-item" v-if="authenticated" v-on:click="logout()">Logout</a>
            </div>
          </div>
        </nav>
      </div>
      <!-- <div class="hero-body ">
      </div> -->
    </section>

    <!-- Start router generated content -->
    <router-view :auth="this.auth"/>
    <!-- end router generated content -->

    <footer class="footer">
      <div class="container">
        <div class="columns is-vcentered">
          <!-- TODO: The logo should align to center when loaded on mobile -->
          <div class="column is-2 has-text-centered">
            <img src="/static/img/ductifi_logo.svg" alt="Logo" style="max-height: 70px;">
            <p>&copy; 2019 Ductifi Pty Ltd <br/> All Rights Reserved</p>
          </div>
          <div class="column is-offset-1">
            <!-- TODO: The form should load on top of the logo when loaded from mobile -->
            <form action="/something" method="post">
              <div class="field has-addons">
                <div class="control is-expanded">
                  <input class="input" type="text" name="email" v-model="emailValue" placeholder="Enter your email address">
                </div>
                <div class="control">
                  <button class="button is-primary" :disabled="$v.emailValue.$invalid">
                    Join the beta
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div class="column is-2 has-text-right-desktop has-text-centered-mobile">
            <!-- TODO: The contact us should align to center when loaded on mobile -->
            <h2>Contact us</h2>
          </div>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
// Import validators
import { required, email } from 'vuelidate/lib/validators'

// Import authentication controller
import AuthService from './auth/AuthService'

const auth = new AuthService()

const { login, logout, authenticated, authNotifier } = auth

export default {
  name: 'App',
  data () {
    authNotifier.on('authChange', authState => {
      this.authenticated = authState.authenticated
    })
    return {
      emailValue: '',
      auth,
      authenticated
    }
  },
  validations: {
    emailValue: {
      email,
      required
    }
  },
  methods: {
    login,
    logout,
    toggleNav () {
      // WTH is tis language?
      var nav = document.getElementById('navbarMenu')
      var className = nav.getAttribute('class')
      if (className === 'navbar-menu') {
        nav.className = 'navbar-menu is-active'
      } else {
        nav.className = 'navbar-menu'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue